module.exports = __webpack_public_path__ + "static/media/photoshop.dda9f7b1.svg";